import Component from '../../js/component';

class Btn extends Component {
  constructor(props) {
    super();

    this.options = {
      loadingText: 'loading...'
    };

    Object.assign(this.options, props);

    this.handlers = {};

    this.$el = $(this.options.el);
    this.oldText = this.$el.text();
    this.loadingText = this.$el.data('loadingText') || this.options.loadingText;
  }

  loading(callback) {
    this.$el.html(this.loadingText).prop('disabled', true);

    if (typeof callback === 'function') {
      callback(this.$el);
    };

    return this;
  }

  reset(callback) {
    this.$el.html(this.oldText).prop('disabled', false);

    if (typeof callback === 'function') {
      callback(this.$el);
    };

    return this;
  }
}

export default Btn;



//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/btn/btn.js
// module id = 546
// module chunks = 9